<template>
  <div class="small-form-grid">
    <div class="grid-x grid-padding-x">
      <div class="cell auto">
        <label for="Katalognr">Katalognr</label>
        <div class="input-container disabled">
          <input id="Katalognr" type="number" :value="objekt.Katalognr" disabled>
        </div>
      </div>
      <div class="cell shrink">
        <label for="Budnr">Spadenr</label>
        <div class="input-container disabled">
          <input v-if="bid.Spadenr" id="Spadenr" type="text" :value="bid.Spadenr" disabled>
          <input v-else id="Spadenr" type="text" :value="'Settes automatisk…'" disabled>
        </div>
      </div>

      <TheAutoCompleteInput
        v-model.trim="customer.parsed_name"
        containerClassName="cell small-12"
        name="Kunde"
        :placeholder="'Søk budgiver…'"
        :label="'Budgiver'"
        :onInputCallback="onKundeSearchInput"
        :onSelectCallback="onKundeSearchSelected"
        :onResetCallback="onKundeSearchReset"
        :debounce="1250"
        :minquery="2"
        :hideErrorMsg="true"
      >
        <label slot="label">
          Budgiver * (<a href="javascript:;" @click="showCustomerModal()">Ny kunde</a>)
        </label>
        <div slot="item" slot-scope="props">
          <strong>{{props.item.Kundenr}}</strong>
          <span v-if="props.item.Bedrift">{{ props.item.FirmaNavn || props.item.full_name }}</span>
          <span v-else>{{ props.item.full_name }}</span>
        </div>
      </TheAutoCompleteInput>

      <div class="cell large-12">
        <input type="hidden" name="Kundenr" v-model="customer.Kundenr" v-validate="rulesCustomer"/>
        <dl class="small-box horizontal" v-if="customer.Kundenr">
          <dt>Kundenr</dt>
          <dd>{{customer.Kundenr}}</dd>

          <dt>Navn</dt>
          <dd>{{customer.parsed_name}}</dd>

          <dt>Mobil</dt>
          <dd>{{customer.Mobil || '-'}}</dd>

          <dt>Tlf. privat</dt>
          <dd>{{customer.Tlfprivat || '-'}}</dd>

          <dt>Tlf. arbeid</dt>
          <dd>{{customer.Tlfarbeid || '-'}}</dd>
        </dl>
      </div>

      <TheSelectInput
        v-model="form.Bruker"
        containerClassName="cell"
        label="Ekspert"
        name="Ekspert"
        data-vv-validate-on="input"
        :items="expertsDropdown"
      />

      <div class="cell">
        <div class="input-container" style="margin-bottom:1rem">
          <label for="Telefonopplysninger">Telefonopplysninger *</label>
          <textarea
            rows="2"
            autocomplete="off"
            placeholder="Legg til telefonopplysninger…"
            v-model="form.Merknad"
            v-validate="'required|max:500'"
            required
            name="Telefonopplysninger"
            id="Telefonopplysninger"
            :class="{ 'error': errors.has('Merknad') }"></textarea>
        </div>
      </div>

      <div class="cell large-12" v-if="errors.all().length > 0">
        <div class="panel small error">
          <ul>
            <li v-if="errors.has('Spadenr')">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              {{errors.first('Spadenr')}}
            </li>
            <li v-if="errors.has('Kundenr')">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              {{errors.first('Kundenr')}}
            </li>
            <li v-if="errors.has('Telefonopplysninger')">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              {{errors.first('Telefonopplysninger')}}
            </li>
          </ul>
        </div>
      </div>

      <div class="cell auto">
        <div class="input-container checkbox">
          <input v-model="form.SendEmail" type="checkbox" name="SendEmail" id="SendEmail">
          <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>

          <label for="SendEmail">Send kvittering til kunde på e-post</label>
        </div>
      </div>

      <template v-if="loading">
        <div class="cell shrink">
          <button type="submit" class="button small primary disabled">Lagre</button>
        </div>
      </template>
      <template v-else-if="changed">
        <div class="cell shrink">
          <button v-if="bid.Spadenr && !deleting" @click="removeConfirm" type="button" class="button small primary transparent">Slett</button>

          <button v-if="!saving" @click="handleSubmit" type="submit" class="button small primary">Lagre</button>
          <button v-else type="submit" class="button small primary loading">Lagre <span class="loader-spinner"></span></button>
        </div>
      </template>
      <template v-else>
        <div class="cell shrink">
          <button v-if="bid.Spadenr && !deleting" @click="removeConfirm" type="button" class="button small primary transparent">Slett</button>

          <button type="submit" class="button small primary disabled">Lagre</button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import KundeService from '@/services/KundeService'
import AuksjonService from '../../../../services/AuksjonService'
import TheAutoCompleteInput from '../../../Inputs/TheAutoCompleteInput'

export default {
  name: 'TheSidebarModule',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput
  },
  props: {
    item: {
      type: Object,
      required: false,
      default: null
    },
    expertsList: {
      type: Array,
      required: false,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      saving: false,
      deleting: false,
      objekt: {},
      bid: {},
      form: {},
      orig: {},
      customer: {},
      expertsDropdown: []
    }
  },
  computed: {
    changed: function () {
      return !this._.isEqual(this.form, this.orig)
    },
    rulesCustomer: function () {
      return {
        required: true,
        min: 1
      }
    }
  },
  watch: {
    item: function (newVal) {
      this.initObject()
    }
  },
  created () {
    bus.$off('kunde_form_saved')

    // Load experts list
    this.expertsDropdown = [{ key: null, val: 'Ikke valgt' }]
    this.expertsList.forEach(el => {
      const disabled = el.Inaktiv === 'T'

      this.expertsDropdown.push({
        key: el.Brukernavn,
        val: disabled ? (el.full_name + ' (inaktiv)') : el.full_name,
        disabled: disabled
      })
    })
  },
  mounted () {
    bus.$on('kunde_form_saved', (data) => this.onKundeCreated(data))

    this.initObject()
  },
  methods: {
    revalidateCustomer: function () {
      const vm = this
      setTimeout(function () {
        vm.$validator.validate('Kundenr')
      })
    },
    addPhoneToMerknad: function () {
      if (!this.form.Merknad) {
        if (this.customer.full_phone) {
          this.form.Merknad = this._.cloneDeep(this.customer.full_phone)
        }
      }
    },
    showCustomerModal: function () {
      // Event: kunde_form_saved
      this.openModal('kunde-card-create-modal')
    },
    onKundeSearchInput: function (query) {
      return KundeService.search(query)
    },
    onKundeCreated: function (data) {
      this.customer = data
      this.form.Kundenr = data.Kundenr
      this.closeModal()
      this.addPhoneToMerknad()
      this.revalidateCustomer()
    },
    onKundeSearchReset: function () {
      this.customer = {}
      this.form.Kundenr = ''
      this.revalidateCustomer()
    },
    onKundeSearchSelected: function (item) {
      this.customer = item || {}
      this.form.Kundenr = String(item.Kundenr || '')

      this.addPhoneToMerknad()
      this.revalidateCustomer()
    },
    initObject: function () {
      // Set object
      this.objekt = this._.cloneDeep(this.item.obj || {})

      // Set current bid if have any...
      this.bid = this._.cloneDeep(this.objekt.telefonbud || {})

      // Make original and form
      this.orig = {
        Kundenr: String(this.bid.Kundenr || ''),
        Merknad: String(this.bid.Merknad || ''),
        Bruker: this.bid.Bruker || null,
        SendEmail: true
      }

      this.form = this._.cloneDeep(this.orig)

      if (this.bid.kunde) {
        this.customer = this._.cloneDeep(this.bid.kunde)
      } else {
        this.customer = {}
      }

      // Clear error bag
      this.errors.clear()
    },
    handleSubmit: function () {
      if (this.saving || !this.changed) {
        return
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
          } else if (this.bid.Telefonbudid) {
            this.update()
          } else {
            this.create()
          }
        })
    },
    create: function () {
      this.saving = true

      // Copy form data and add what's need for save
      const save = Object.assign(
        {},
        this._.cloneDeep(this.form),
        {
          Auksjon: this.objekt.Auksjon,
          Kontraktnr: this.objekt.Kontraktnr,
          Lopenr: this.objekt.Lopenr,
          Avdelingsid: this.objekt.Avdelingsid
        }
      )

      AuksjonService.createTelefonbud(save)
        .then(response => {
          this.$emit('on-save', response.data)
        })
        .catch(error => {
          console.log('Error', error)
          this.$helpers.sendApiErrorsToValidator(error, this.errors)

          // Check if new errors appeared
          if (this.errors.any()) {
            this.$validator.resume()
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.$helpers.showErrorAlert('Feil', 'Noe gikk feil i lagringen.')
          }
        })
        .then(() => {
          this.saving = false
        })
    },
    update: function () {
      this.saving = true

      const save = this._.cloneDeep(this.form)

      AuksjonService.updateTelefonbud(this.bid.Telefonbudid, save)
        .then(response => {
          this.$emit('on-save', response.data)
        })
        .catch(error => {
          console.log('Error', error)
          this.$helpers.sendApiErrorsToValidator(error, this.errors)

          // Check if new errors appeared
          if (this.errors.any()) {
            this.$validator.resume()
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.$helpers.showErrorAlert('Feil', 'Noe gikk feil i lagringen.')
          }
        })
        .then(() => {
          this.saving = false
        })
    },
    removeConfirm: function () {
      const vm = this
      this.openConfirm(
        'Ønsker du å slette dette telefonbud?',
        'Denne handlingen kan ikke angres.',
        'Ja',
        'Nei',
        function () {
          vm.closeModal()
          vm.remove()
        },
        function () {
          vm.closeModal()
        }
      )
    },
    remove: function () {
      this.deleting = true

      AuksjonService.deleteTelefonbud(this.bid.Telefonbudid)
        .then(response => {
          this.$emit('on-delete', {
            Objektid: this.objekt.Objektid,
            Telefonbudid: this.bid.Telefonbudid
          })
        })
        .catch(error => {
          console.log('Error', error)
          this.$helpers.showErrorAlert('Feil', 'Noe gikk feil i lagringen.')
        })
        .then(() => {
          this.deleting = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Telefonbud/TheSidebarModule.vue